import { formatCurrency } from '@/utils/formatters';

/** Whole units only: the matrix has no room for cents. */
export const formatMatrixAmount = (amount: number, currency: string): string =>
  formatCurrency(amount, {
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
